module.exports = __webpack_public_path__ + "static/lframe-pay-any-way-546d033ef1a7dad94dcd55f607b83696.png";